import fetch from "@/config/axios-fetch";
/**
 * 基础接口
 * author:zhuwei
 */
//登陆
export const login = data => fetch("/api/system/login", data, "POST");
//注册
export const register = data => fetch("/api/app/register", data, "POST");
//获取我所属的一级小组
export const getMyGroups = data => fetch("/api/group/getMyGroups", data);
//获取某个小组的会诊小组
export const getConsultationGroups = data => fetch("/api/group/getConsultationGroups", data);
//获取某个小组的医生小组
export const getDoctorGroup = data => fetch("/api/group/getDoctorGroup", data);
//获取用户信息
export const getuserInfo = data => fetch("/api/user/userInfo", data);
//分页获取方案列表
export const getPlanPageList = data => fetch("/api/plan/getPlanPageList", data);
//获取待汇总方案列表
export const getAllUnSummaryPlans = data => fetch("/api/plan/getAllUnSummaryPlans", data);
//编辑方案
export const editPlan = data => fetch("/api/plan/editPlan", data, 'POST');
//获取方案详情
export const getPlanInfo = data => fetch("/api/plan/getPlanInfo", data);
//获取与汇总方案相关联的方案
export const getRelPlans = data => fetch("/api/plan/getRelPlans", data);
//获取某个会诊小组的用户信息
export const getConsultationPorUserInfo = data => fetch("/api/group/getConsultationPorUserInfo", data);
//获取我提交的方案
export const getMyPlans = data => fetch("/api/plan/getMyPlans", data);
//新增方案
export const savePlan = data => fetch("/api/plan/savePlan", data, 'POST');
//删除方案
export const delPlan = data => fetch("/api/plan/delPlan", '', 'POST', data);
//获取我的医生小组
export const getMyDoctorGroups = data => fetch("/api/group/getMyDoctorGroups", data);
//获取小组的私密问诊用户信息
export const getSecretUsers = data => fetch("/api/group/getSecretUsers", data);
//条件查询病例报告列表
export const userCaseReportList = data => fetch("/api/porUser/userCaseReportList", data);
//查询会员档案
export const searchMemberRecord = data => fetch("/api/porUser/searchMemberRecord", data);
//获取某个小组的患者列表
export const getPorUserByDoctorGroup = data => fetch("/api/group/getPorUserByDoctorGroup", data);
//获取某个小组所有IM小组的未读消息总
export const getGroupCount = data => fetch("/api/imMessage/getGroupCount", data);
//获取单个会诊小组的未读消息
export const getSingleHzGroupCount = data => fetch("/api/imMessage/getSingleHzGroupCount", data);
//发送消息时计数
export const counting = data => fetch("/api/imMessage/counting", data, 'POST');
//清除单个会诊小组的未读消息
export const clearSingleHzGroupCount = data => fetch("/api/imMessage/clearSingleHzGroupCount", data);
//获取单个医生小组的未读消息
export const getSingleYsGroupCount = data => fetch("/api/imMessage/getSingleYsGroupCount", data);
//获取单个私密问诊的未读消息
export const getSingleSmGroupCount = data => fetch("/api/imMessage/getSingleSmGroupCount", data);
//清除单个医生小组的未读消息
export const clearSingleYsGroupCount = data => fetch("/api/imMessage/clearSingleYsGroupCount", data);
//清除单个私密问诊的未读消息
export const clearSingleSmGroupCount = data => fetch("/api/imMessage/clearSingleSmGroupCount", data);
//查询提醒消息
export const remindlist = data => fetch("/api/health/remind/list", data);
//查询是否有未读提醒消息 true-有 false-无
export const getRead = data => fetch("/api/health/remind/getRead", data);
//置已读
export const setRead = data => fetch("/api/health/remind/setRead", data, 'POST');
//分页获取某个小组的会诊小组
export const getConsultationGroupsPage = data => fetch("/api/group/getConsultationGroupsPage", data);




// WEBPACK FOOTER //
// ./src/api/getData.js